"use client";

import type {
  FilterSection,
  FilterSelect,
  SearchField,
  FilterOption,
  FilterOptionInline,
} from "@/generated/sb";
import {
  FilterSection as UIFilterSection,
  FilterField,
  FilterValues,
} from "@repo/ui-parkmobile/sections/FilterSection";
import { DropdownOption } from "@repo/ui-parkmobile/Dropdown";
import { storyblokEditable } from "@storyblok/react/rsc";
import { useState, useCallback } from "react";

export function FilterSection({ blok }: { blok: FilterSection }) {
  const [filterState, setFilterState] = useState<FilterValues>({});

  const handleFiltersChange = useCallback((filters: FilterValues) => {
    setFilterState(filters);

  }, []);

  const handleFieldChange = useCallback((_fieldName: string, _value: string) => {

  }, []);

  const fields: (FilterField & { _editable?: any })[] = (blok.fields || []).map((field, index) => {
    if (field.component === "searchField") {
      const searchField = field as SearchField;
      return {
        type: "search" as const,
        name: searchField._uid,
        placeholder: searchField.placeholder || "Search by location or venue",
        _editable: storyblokEditable(searchField),
      };
    }

    if (field.component === "filterSelect") {
      const filterSelect = field as FilterSelect;
      return {
        type: "dropdown" as const,
        name: filterSelect._uid,
        placeholder: filterSelect.placeholder || "Select an option",
        options: (filterSelect.options || []).map(
          (option: FilterOption | FilterOptionInline) => ({
            label: option.title || String(option.value) || "Option",
            value: String(option.value) || option._uid,
            _editable: storyblokEditable(option),
          } as DropdownOption & { _editable?: any }),
        ),
        _editable: storyblokEditable(filterSelect),
      };
    }


    const unknownField = field as { _uid?: string };
    return {
      type: "search" as const,
      name: unknownField._uid || `field-${index}`,
      placeholder: "Search...",
      _editable: storyblokEditable(field),
    };
  });

  return (
    <UIFilterSection
      {...storyblokEditable(blok)}
      fields={fields}
      backgroundColor={blok.backgroundColor || "none"}
      topPadding={blok.topPadding || "none"}
      bottomPadding={blok.bottomPadding || "none"}
      initialValues={filterState}
      onFiltersChange={handleFiltersChange}
      onFieldChange={handleFieldChange}
      id={blok.anchor}
    />
  );
}
